module.exports = __webpack_public_path__ + "media/pricing/Work_Order-34b1c8a6.pdf";